import React, { useState, useEffect } from "react";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import { SlOption, SlSelect, SlInput, SlIcon, } from '@shoelace-style/shoelace/dist/react';
import { useNavigate } from "react-router";
import api from "../../services/api";
import { formatDate } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import Paginator from "../../shared/Paginator";
import { useDispatch, useSelector } from 'react-redux';
import config from "../../config";
import TableLoader from "../../shared/TableLoader";
import { debounce } from "../../utils/Debounce";
import Datepicker from "react-tailwindcss-datepicker";
import { toast } from "react-toastify";


function AdRequests() {
    const navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [type, setType] = useState("National");
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [data, setData] = useState([]);
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
    const [search, setSearch] = useState("");


    const HeaderSearch = useSelector(state => state.Head.adssearch);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        loadData(search, event.selected, type, dateRange);
    };

    const loadData = async (searchString = "", page = 0, type, dateRange) => {
        try {
            setLoader(true);
            let res = await api({
                url: `/adrequest/getAdRequests`,
                method: "POST",
                responseType: "json",
                data: {
                    page: page,
                    limit: config.PER_PAGE,
                    search: searchString,
                    type: type,
                    date: dateRange
                },
            });
            if (res?.code === 200) {
            setData(res.data.result.res.length ? res.data.result.res : []);
            setTotalPages(Math.ceil(res.data.result.totalCount / config.PER_PAGE));
            setLoader(false);
            }
            else {
                toast.error(res?.data?.message)
            }
        } catch (error) {
            //Toast.error("Something went wrong")
            if (error?.res?.status === 401) navigate("/");
        }
    };

    useEffect(() => {
        Header()
    }, [HeaderSearch])

    const Header = () => {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        loadData(HeaderSearch, 0, type, dateRange);
    }

    const searchData = (e) => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0, type, dateRange);
    };


    const typeSearch = (e) => {
        setType(e.target.value);
        setCurrentPage(0);
        setSearch(prev => "")
        setDateRange({ startDate: null, endDate: null });
        loadData("", 0, e.target.value, { startDate: null, endDate: null });
    };

    const handleDateRange = (selectedDate) => {
        // setData([]);
        setCurrentPage(0)
        if (selectedDate) {
            if (selectedDate.startDate && selectedDate.endDate) {
                setDateRange(selectedDate);
                loadData(search, currentPage, type, selectedDate)
            } else {
                setDateRange({ startDate: null, endDate: null });
                loadData(search, currentPage, type, { startDate: null, endDate: null })

            }
        } else {
            setDateRange({ startDate: null, endDate: null });
            loadData(search, currentPage, type, { startDate: null, endDate: null })

        }
    }

    return (
        <div>
            <div className="flex items-center gap-3 mb-3">
                <aside className="ml-auto flex items-center gap-3 flex-wrap">
                    <div className="w-40">
                        <SlSelect onSlChange={typeSearch} size="small" placeholder="National">
                            <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
                            <SlOption value="National">National </SlOption>
                            <SlOption value="Local">Local </SlOption>
                            <SlOption value="TamilNadu">TamilNadu </SlOption>

                        </SlSelect>
                    </div>

                    <div className="w-40">
                        <SlInput type="text"
                            size="small"
                            id="myInput"
                            value={search}
                            onSlInput={debounce(searchData, 500)}
                            placeholder="Search By Name / Email / Mobile / Type">
                            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                        </SlInput>

                    </div>

                    <div className='border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66'>
                        <Datepicker
                            classNames="form-input"
                            value={dateRange}
                            primaryColor={"cyan"}
                            showShortcuts={true}
                            useRange={true} // Allow date range selection
                            configs={{
                                shortcuts: {
                                    today: "today",
                                    yesterday: "yesterday",
                                    currentMonth: "currentMonth",
                                    pastMonth: "lastMonth",

                                }
                            }}
                            onChange={handleDateRange}
                        />
                    </div>
                </aside>
            </div >

            <div className="overflow-x-auto mb-4">
                <ScrollContainer>
                    <table className='table table-bordered '>
                        <thead className="sticky top-0  ">
                            <tr>
                                <th > Name</th>
                                <th >Type</th>
                                <th >Team</th>
                                <th >Email</th>
                                {type === "TamilNadu" ? <th >Agency District</th> : null}
                                {type === "National" ? <th >Brand Name</th> : null}
                                <th >Agency Name </th>
                                <th >Client Name </th>
                                <th >Client Mobile</th>
                                <th >Client Email</th>
                                {type !== "National" ? <th >Client GST</th> : null}
                                {type !== "National" ? <th >Client Business Name</th> : null}
                                {type !== "National" ? <th >Business Category</th> : null}
                                {type !== "National" ? <th >Office Location</th> : null}
                                {type !== "National" ? <th >Ad Location District</th> : null}
                                {type !== "National" ? <th >Ad Location Mandal</th> : null}
                                {type !== "National" ? <th >Ad Unit</th> : null}
                                {type !== "National" ? <th >Position</th> : null}
                                <th >Ad Format</th>
                                <th >Campaign Mode</th>
                                <th >RO Value </th>
                                {type === "National" ? <th >CPC/CPM Cost </th> : <th >Ad Cost </th>}
                                {type !== "National" ? <th >Payment Type </th> : null}
                                {type !== "National" ? <th >Transaction Id </th> : null}
                                {type !== "National" ? <th >Comments </th> : null}
                                {type !== "National" ? <th >Agency Commission </th> : null}
                                {type !== "National" ? <th >Package Details </th> : null}
                                {type !== "National" ? <th >Credit Period </th> : null}
                                {type === "TamilNadu" ? <th >Content Reference </th> : null}
                                {type !== "National" ? <th >Client Info </th> : null}
                                {type === "National" ? <th >Start Date </th> : <th >Ad to be Published On</th>}
                                {type === "National" ? <th >End Date </th> : null}
                                {type === "National" ? <th >Target Location </th> : null}
                                {type === "National" ? <th >Campaign Objective </th> : null}
                                {/* <th >RO File </th> */}



                            </tr>
                        </thead>
                        {data?.length && !loader ? (
                            <tbody>
                                {data.map((item, index) => {
                                    return (
                                        <tr key={item.req_id} className="group/details hover:bg-slate-100">
                                            <th scope="row">{item.name}</th>
                                            <td>{item.type || "-"}</td>
                                            <td>{item.team}</td>
                                            <td>{item.email}</td>
                                            {item.type === "TamilNadu" ? <td>{item.agency_district || "-"}</td> : null}
                                            {type === "National" ? <td>{item.brand_name || "-"}</td> : null}
                                            <td>{item.agency_name || "-"}</td>
                                            <td>{item.client_name || "-"}</td>
                                            <td>{item.client_mobile || "-"}</td>
                                            <td>{item.client_email || "-"}</td>
                                            {type !== "National" ? <td>{item.client_gst || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.client_business_name || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.business_category || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.office_location || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.ad_location_district || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.ad_location_mandal || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.ad_unit || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.position || "-"}</td> : null}
                                            <td>{item.ad_format || "-"}</td>
                                            <td>{item.campaign_mode || "-"}</td>
                                            <td>{item.ro_value || "-"}</td>
                                            <td>{item.cpc_cpm_cost || "-"}</td>
                                            {type !== "National" ? <td>{item.payment_type || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.transaction_id || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.comments || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.agency_commission || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.package_details || "-"}</td> : null}
                                            {type !== "National" ? <td>{(item.credit_period ? formatDate(item?.credit_period) : "-")}</td> : null}
                                            {type === "TamilNadu" ? <td>{item.content_reference || "-"}</td> : null}
                                            {type !== "National" ? <td>{item.client_info || "-"}</td> : null}
                                            <td>{(item.start_date ? formatDate(item?.start_date) : "-")}</td>
                                            {type === "National" ? <td>{(item.end_date ? formatDate(item?.end_date) : "-")}</td> : null}
                                            {type === "National" ? <td>{item.target_location || "-"}</td> : null}
                                            {type === "National" ? <td>{item.campaign_objective || "-"}</td> : null}

                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : !data?.length && !loader ? (
                            <NoDataFound colspan="17" />
                        ) : (
                            <TableLoader colspan="17" />
                        )}
                    </table>
                </ScrollContainer>
            </div>
            <div className="flex justify-end">
                {totalPages > 1 && (
                    <Paginator
                        pageCount={totalPages}
                        handlePageClick={handlePageClick}
                        forcePage={currentPage}
                    />
                )}</div>
        </div >
    );
}

export default AdRequests;
